import {styled} from '@linaria/react';
import React, {ComponentProps} from 'react';
import {COLORS} from '../../../../constants/colors';
import {SPACING} from '../../../../constants/sizing';
import {Button} from '../../Buttons/Button';

type ContentPopperButtonsProps = Omit<
  ComponentProps<typeof Button>,
  'children'
> & {
  label: string;
};

/* Used for Cancel Button */
export const PrimaryContentPopperButton: React.FC<
  ContentPopperButtonsProps
> = ({label, ...rest}) => {
  return (
    <Button variant="primary" aria-label={label} {...rest}>
      {label}
    </Button>
  );
};

/* Used for Cancel Button */
export const SecondaryContentPopperButton: React.FC<
  ContentPopperButtonsProps
> = ({label, ...rest}) => {
  return (
    <StyledSecondaryButton variant="secondary" aria-label={label} {...rest}>
      {label}
    </StyledSecondaryButton>
  );
};

const StyledSecondaryButton = styled(Button)`
  width: 100%;
  padding-inline: ${SPACING['X.Xl2']};
`;

export const FooterWrapper = styled.div`
  background-color: ${COLORS['Fill.White']};
  display: flex;
  gap: ${SPACING['X.Lg']};
  padding: ${SPACING['Y.Lg']};

  & > * {
    // Default: secondary CTA takes 45%, primary CTA takes 55%
    // Use calc to account for gap and ensure buttons don't overflow
    &:first-child {
      flex: 0 0 calc(45% - ${SPACING['X.Lg']} / 2);
      // Allow shrinking if needed
      min-width: 0;
    }

    &:last-child {
      flex: 0 0 calc(55% - ${SPACING['X.Lg']} / 2);
      // Allow shrinking if needed
      min-width: 0;
    }

    // If only one child (secondary CTA), it takes full width
    &:only-child {
      flex: 1;
    }
  }
`;
